/**
 * 公开不公开组件
 * created by yxy
 *
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button,Modal,Radio } from 'antd';
import {message} from './Mess'
import BaseComponent from "../../../base/BaseComponent";
import CmForm from "../../../components/CmForm/CmForm";
const { confirm } = Modal


export default class IsOpen  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            visible:false,
            value: 1
        }
    }
    componentWillMount() {
    }
    componentDidMount() {
    }
    render() {
        return (
            <>
                <div>{this.props.text ? <span  style={{cursor:"pointer"}} onClick={()=>{this.settingOpen()}}>设置公开</span> :
                    <Button style={{marginRight: 5}} icon={"setting"}  onClick={()=>{this.settingOpen()}}>设置公开</Button>}
                </div>
                <Modal
                    maskClosable={false}
                    keyboard={true}
                    title="设置公开"
                    visible={this.state.visible}
                    centered
                    onOk={() => {
                        this.handleOk()
                    }}
                    destroyOnClose={true}
                    okText={'保存'}
                    zIndex={999}
                    width={300}
                    onCancel={() => {
                        this.setState({visible: false});

                    }}
                >
                    <CmForm onSubmit={() => {
                        this.handleOk()
                    }}>
                        <>
                            <div style={{textAlign: "center"}}>
                                <Radio.Group onChange={this.onChange} value={this.state.value}>
                                    <Radio value={1}  autoFocus={true} >公开</Radio>
                                    <Radio value={2}  >不公开</Radio>
                                </Radio.Group>
                            </div>
                            <div style={{marginTop: 32,padding:8, fontSize: 12, color: 'rgba(245, 108, 108)', textAlign: 'center',background:'rgba(245, 108, 108, 0.1)'}}>
                                <div>公开：所有人员可通过公共资源查看</div>
                                <div>不公开：仅本单位人员或本人可查看</div>
                            </div>
                            </>
                    </CmForm>
                </Modal>
            </>
        )
    }

    settingOpen(){
        this.props.hideCallBack&&this.props.hideCallBack();
        let fileNum = 0;
        let folderNum = 0;
        if (this.props.checkArray && this.props.checkArray.length) {
            this.props.checkArray.forEach((item, index) => {
                if (item.fileTypeEnum === 'DIR') {
                    folderNum++
                } else {
                    fileNum++
                }
            });
            if(fileNum === this.props.checkArray.length){
                message.error('仅文件夹可设置公开！')
            }else if(folderNum>0&&fileNum>0){
                confirm({
                    content: '暂不支持文件公开，仅公开当前选中的文件夹？',
                    okText: '确定',
                    cancelText: '取消',
                    onOk:()=> {
                            this.setState({visible:true})
                    },
                    onCancel() {
                    },
                });
            }else{
                this.setState({visible:true})
            }
        } else {
            message.error('至少选择一个文件夹！')
        }
        this.setState({value:1})
    }
    onChange = e => {
        this.setState({
            value: e.target.value,
        });
    };
    handleOk(){
        let ids = [];
        this.props.checkArray&&this.props.checkArray.length&&this.props.checkArray.forEach((item,index)=>{
            if(item.fileTypeEnum === 'DIR'){
                ids.push(item.id)
            }
        });
        let url;
        if(this.state.value === 1){
            url = "/cm-sites-storage-management/zykFile/publicFolder"
        }else{
            url = "/cm-sites-storage-management/zykFile/privateFolder"
        }
        if(ids){
            this.request({
                url: url,
                method: "post",
                body: {virtualFileIds:ids.join(',')},
                contentType: "json",
                callBack: (data) => {
                    if (data) {
                        message.success('保存成功');
                        this.setState({visible:false});
                        //当前点击的id (props传过去的参数)
                        //当前的树id
                        //当前选中的数组
                        //是否更新当前数据
                        //是否跳转去第一页
                        // this.props.callBack&&this.props.callBack(this.props.currentId,this.props.current, this.props.checkArray,true,false);
                        this.props.callBack&&this.props.callBack()
                    }
                }
            });
        }

    }
}
